module.exports = __webpack_public_path__ + "img/78e0a86.jpg";